import React from 'react';
import { ContainerFileCardStyled as ContainerFileCard, FileIconStyled as FileIcon, FileInfoStyled as FileInfo, LightCrossStyled as LightCross } from './styles/FileUploadedStyled';
;
var FileUploaded = function FileUploaded(_ref) {
  var filename = _ref.filename,
    setFile = _ref.setFile;
  return React.createElement(ContainerFileCard, null, React.createElement(FileIcon, null), React.createElement(FileInfo, null, filename), React.createElement(LightCross, {
    onClick: function onClick() {
      return setFile();
    }
  }));
};
export default FileUploaded;